<template>
  <div class="relative canvas-wrapper">
    <Ad id="222" />
    <div id="canvas"/>
  </div>
</template>

<script>

import { Pixel } from '../../core/src/lib';
import Button from '../../core/src/components/Button'
import Ad from '../../core/src/components/Ad'

export default {
  data() {
    return {
      Pixel
    }
  },
  components: {
    Button,
    Ad
  },
  mounted() {
    Pixel.init({
      canvasElement: "canvas",
      callback: () => {
        const copy = Pixel.add({ type: "Copy" });
        Pixel.add({ type: "Line", parent: copy });
        copy.renderBuffer()
        Pixel.setSelected(copy)
      },
    });
  }
};
</script>

<style scoped lang="postcss">
.canvas-wrapper {
  @apply flex flex-col bg-gray-100 w-full items-center justify-center;
}
#canvas {
  @apply bg-white;
  filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.02))
    drop-shadow(0 4px 3px rgb(0 0 0 / 0.02));
}

</style>